import {useState, useEffect, useCallback} from 'react';
import * as CandidatesApi from '../api';

const useDuplicateDetection = candidateId => {
  const [duplicateData, setDuplicateData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [err, setError] = useState(false);

  const checkForDuplicates = useCallback(async () => {
    if (!candidateId) return;

    setLoading(true);
    setError(false);
    try {
      const response = await CandidatesApi.getPossibleDuplicates(candidateId);
      const duplicateResponse = response.data || response;

      setDuplicateData(duplicateResponse);
    } catch (error) {
      console.error('Error checking for duplicates:', error);
      setDuplicateData(null);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [candidateId]);

  const clearDuplicateData = useCallback(() => {
    setDuplicateData(null);
  }, []);

  useEffect(() => {
    checkForDuplicates();
  }, [checkForDuplicates]);

  return {
    duplicateData,
    loading,
    err,
    checkForDuplicates,
    clearDuplicateData,
    hasDuplicates: duplicateData?.dupes?.length > 0,
  };
};

export default useDuplicateDetection;
